import { render, staticRenderFns } from "./slice-down-arrow-icon.vue?vue&type=template&id=6c017b76"
import script from "./slice-down-arrow-icon.vue?vue&type=script&lang=js"
export * from "./slice-down-arrow-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports